import moment from 'moment';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */

function drawCabeceraLogo(doc, empresa, fontName) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const orientation = pageWidth > pageHeight ? 'landscape' : 'portrait';
  const isPortrait = pageHeight > pageWidth;

  /* Barra */
  doc.setDrawColor(0);
  // doc.setFillColor(232, 67, 113);
  doc.setFillColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  
  if (isPortrait) {
    doc.rect(0, 0, 210, 5, 'F');
  } else {
    doc.rect(0, 0, 297, 5, 'F');
  }
  // doc.rect(0, 0, 210, 5, 'F');

  /* Logo */
  if (empresa.logo.trim() != '') {
    let logo = `data:image/png;base64,${empresa.logo.trim()}`;
    doc.addImage(logo, 'PNG', 10, 12, 44, 22, undefined, 'FAST');
  }

  /* Logo WeConnect*/
  if (empresa.logoWeConnect.trim() != '') {
    let logoWC = `data:image/png;base64,${empresa.logoWeConnect.trim()}`;

    if (isPortrait) {
      doc.addImage(logoWC, 'PNG', 164, 12, 17, 17, undefined, 'FAST');
    } else {
      doc.addImage(logoWC, 'PNG', 251, 12, 17, 17, undefined, 'FAST');
    }
  }
  
  /* Logo Ecovadis */
  if (empresa.logoEcovadis.trim() != '') {
    let logoEcovadis = `data:image/png;base64,${empresa.logoEcovadis.trim()}`;

    if (isPortrait) {
      doc.addImage(logoEcovadis, 'PNG', 183, 13, 16, 16, undefined, 'FAST');
    } else {
      doc.addImage(logoEcovadis, 'PNG', 270, 13, 16, 16, undefined, 'FAST');
    }
  }

  /* Razón social */
  doc.setFontSize(7);
  doc.setFont(fontName, 'normal');
  doc.setTextColor(151, 148, 149);
  doc.text(empresa.razonSocial.trim(), 10, 38);
}

function drawCabeceraEmpresa({doc, empresa, fontName, dark, fontSize, logoAsociado}) {
  let alignRight = {
    'align': 'right'
  }

  /* Barra */
  doc.setDrawColor(0);
  // doc.setFillColor(232, 67, 113);
  doc.setFillColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  doc.rect(0, 0, 210, 5, 'F');

  /* Logo */
  if (empresa.logo.trim() != '') {
    let logo = `data:image/png;base64,${empresa.logo.trim()}`;
    doc.addImage(logo, 'PNG', 10, 12, 44, 22, undefined, 'FAST');
  }

  if ((/true/i).test(logoAsociado)) {
    /* Logo WeConnect*/
    if (empresa.logoWeConnect.trim() != '') {
      let logoWC = `data:image/png;base64,${empresa.logoWeConnect.trim()}`;
      // doc.addImage(logoWC, 'PNG', 172, 11, 22, 22, undefined, 'FAST');
      doc.addImage(logoWC, 'PNG', 164, 12, 17, 17, undefined, 'FAST');
    }
    /* Logo Ecovadis */
    if (empresa.logoEcovadis.trim() != '') {
      let logoEcovadis = `data:image/png;base64,${empresa.logoEcovadis.trim()}`;
      doc.addImage(logoEcovadis, 'PNG', 183, 13, 16, 16, undefined, 'FAST');
    }
  }

  fontSize = fontSize || 7;
  // let fontSize = dataFontSize || 7;
  doc.setFontSize(fontSize);
  
  doc.setFont(fontName, 'normal');
  
  if ((/true/i).test(dark)) {
    doc.setTextColor(60, 60, 60);
  } else {
    doc.setTextColor(151, 148, 149);
  }
  
  let positionY = 0;
  let interlineadoDatos = 4;

  if (!(/true/i).test(logoAsociado)) {
    positionY = 28;
    doc.text(`${empresa.tipoDocumento.trim()}: ${empresa.documentoNumero.trim()}`, 200, positionY, alignRight);
  
    if (empresa.ingresosBrutos.trim() != '') {
      positionY += interlineadoDatos;
      doc.text(`Ingresos Brutos: ${empresa.ingresosBrutos.trim()}`, 200, positionY, alignRight);
    }
    
    if (empresa.inicioActividades.trim() != '') {
      positionY += interlineadoDatos;
      doc.text(`Fecha de Inicio de Actividades: ${empresa.inicioActividades.trim()}`, 200, positionY, alignRight);
    }
  }

  if ((/true/i).test(logoAsociado)) {
    positionY = 45;
  } else {
    positionY = 40;
  }

  /* Razon Social */
  doc.text(empresa.razonSocial.trim(), 10, positionY);

  positionY += interlineadoDatos;
  /* Domicilio */
  doc.text(`Domicilio: ${empresa.direccion.trim()}`, 10, positionY);

  if (empresa.sucursalDireccion) {
    let sucursalTitulo = 'Sucursal';
    if (empresa.sucursalTitulo) {
      sucursalTitulo = empresa.sucursalTitulo.trim();
    }
    positionY += interlineadoDatos;
    /* Sucursal */
    doc.text(`${sucursalTitulo}: ${empresa.sucursalDireccion}`, 10, positionY);
  }
  if ((/true/i).test(logoAsociado)) {
    /* Cuit */
    doc.text(`${empresa.tipoDocumento.trim()}: ${empresa.documentoNumero.trim()}`, 200, positionY, alignRight);
  }

  positionY += interlineadoDatos;
  /* Telefono */
  doc.text(`Teléfono: ${empresa.telefono.trim()}`, 10, positionY);
  if ((/true/i).test(logoAsociado)) {
    /* Ingresos Brutos*/
    if (empresa.ingresosBrutos.trim() != '') {
      doc.text(`Ingresos Brutos: ${empresa.ingresosBrutos.trim()}`, 200, positionY, alignRight);
    }
  }

  positionY += interlineadoDatos;
  /* Email */
  doc.text(`Email: ${empresa.email.trim()}`, 10, positionY);
  if ((/true/i).test(logoAsociado)) {
    /* Fecha de Inicio */
    if (empresa.inicioActividades.trim() != '') {
      /* Fecha de Inicio */      
      doc.text(`Fecha de Inicio de Actividades: ${empresa.inicioActividades.trim()}`, 200, positionY, alignRight);
    }
  }
}

function drawCabeceraFiscalEmpresa({doc, empresa, fontName, ajusteY, dark, logoAsociado}) {
  let alignRight = {
    'align': 'right'
  }

  /* Barra */
  doc.setDrawColor(0);
  // doc.setFillColor(232, 67, 113);
  doc.setFillColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  doc.rect(0, 0, 210, 5, 'F');

  /* Logo */
  if (empresa.logo.trim() != '') {
    let logo = `data:image/png;base64,${empresa.logo.trim()}`;
    doc.addImage(logo, 'PNG', 10, 12, 44, 22, undefined, 'FAST');
  }

  if ((/true/i).test(logoAsociado)) {
    /* Logo WeConnect*/
    if (empresa.logoWeConnect.trim() != '') {
      let logoWC = `data:image/png;base64,${empresa.logoWeConnect.trim()}`;
      // doc.addImage(logoWC, 'PNG', 172, 11, 22, 22, undefined, 'FAST');
      doc.addImage(logoWC, 'PNG', 164, 12, 17, 17, undefined, 'FAST');
    }
    /* Logo Ecovadis */
    if (empresa.logoEcovadis.trim() != '') {
      let logoEcovadis = `data:image/png;base64,${empresa.logoEcovadis.trim()}`;
      doc.addImage(logoEcovadis, 'PNG', 183, 13, 16, 16, undefined, 'FAST');
    }
  }

  doc.setFontSize(7);
  doc.setFont(fontName, 'normal');
  
  if ((/true/i).test(dark)) {
    doc.setTextColor(60, 60, 60);
  } else {
    doc.setTextColor(151, 148, 149);
  }
  
  let positionY = 0;
  let interlineadoDatos = 4;
  ajusteY = ajusteY || 0;

  if (!(/true/i).test(logoAsociado)) {
    positionY = 28 + ajusteY;
    doc.text(`${empresa.tipoDocumento.trim()}: ${empresa.documentoNumero.trim()}`, 200, positionY, alignRight);
    
    if (empresa.ingresosBrutos.trim() != '') {
      positionY += interlineadoDatos;
      doc.text(`Ingresos Brutos: ${empresa.ingresosBrutos.trim()}`, 200, positionY, alignRight);
    }
    
    if (empresa.inicioActividades.trim() != '') {
      positionY += interlineadoDatos;
      doc.text(`Fecha de Inicio de Actividades: ${empresa.inicioActividades.trim()}`, 200, positionY, alignRight);
    }    
  }

  if ((/true/i).test(logoAsociado)) {
    positionY = 45 + ajusteY;
  } else {
    positionY = 40 + ajusteY;
  }
  doc.text(empresa.razonSocial.trim(), 10, positionY);

  positionY += interlineadoDatos;
  doc.text(`Domicilio: ${empresa.direccion.trim()}`, 10, positionY);
  if ((/true/i).test(logoAsociado)) {
    doc.text(`${empresa.tipoDocumento.trim()}: ${empresa.documentoNumero.trim()}`, 200, positionY, alignRight);
  }

  positionY += interlineadoDatos;
  doc.text(`Teléfono: ${empresa.telefono.trim()}`, 10, positionY);
  if ((/true/i).test(logoAsociado)) {
    if (empresa.ingresosBrutos.trim() != '') {
      doc.text(`Ingresos Brutos: ${empresa.ingresosBrutos.trim()}`, 200, positionY, alignRight);
    }
  }

  positionY += interlineadoDatos;
  doc.text(`Email: ${empresa.email.trim()}`, 10, positionY);
  if ((/true/i).test(logoAsociado)) {
    if (empresa.inicioActividades.trim() != '') {
      doc.text(`Fecha de Inicio de Actividades: ${empresa.inicioActividades.trim()}`, 200, positionY, alignRight);
    }
  }
}

function drawFooterEmpresa(doc, empresa, fontName) {
const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const orientation = pageWidth > pageHeight ? 'landscape' : 'portrait';
  const isPortrait = pageHeight > pageWidth;

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  if (isPortrait) {
    doc.line(10, 280, 200, 280);
  } else {
    doc.line(10, 193, 287, 193);
  }

  doc.setFontSize(10);
  doc.setFont(fontName, 'normal');
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  
  let website = empresa.website.trim();
  let length = website.length;
  if (isPortrait) {
    let spaces = (150 - length) / 2;
    doc.textWithLink(website.trim(), 18 + spaces, 286, {url: `https://${website}`});
  } else {
    let spaces = (230 - length) / 2;
    doc.textWithLink(website.trim(), 18 + spaces, 199, {url: `https://${website}`});
  }

  if (empresa.instagram.trim() != '') {
    let logoIg = `data:image/png;base64,${empresa.logoInstagram.trim()}`;
    if (isPortrait) {
      doc.addImage(logoIg, 'PNG', 76, 289, 3, 3, undefined, 'FAST');
    } else {
      doc.addImage(logoIg, 'PNG', 112, 202, 3, 3, undefined, 'FAST');
    }

    doc.setFontSize(6);
    if (isPortrait) {
      doc.textWithLink(empresa.instagram.trim(), 80, 291, {url: empresa.instagramUrl.trim()});
    } else {
      doc.textWithLink(empresa.instagram.trim(), 116, 204, {url: empresa.instagramUrl.trim()});
    }
  }
      
  if (empresa.linkedin.trim() != '') {
    let logoLinkedin = `data:image/png;base64,${empresa.logoLinkedin.trim()}`;
    if (isPortrait) {
      doc.addImage(logoLinkedin, 'PNG', 114, 289, 3, 3, undefined, 'FAST');
    } else {
      doc.addImage(logoLinkedin, 'PNG', 157, 202, 3, 3, undefined, 'FAST');
    }

    doc.setFontSize(6);
    if (isPortrait) {
      doc.textWithLink(empresa.linkedin.trim(), 118, 291, {url: empresa.linkedinUrl.trim()});
    } else {
      doc.textWithLink(empresa.linkedin.trim(), 162, 204, {url: empresa.linkedinUrl.trim()});
    }
  }

  doc.setFontSize(6);
  doc.setTextColor(0, 0, 0);
  if (isPortrait) {
    doc.text(`Fecha de Emisión: ${moment.utc(new Date()).add(-3, 'hours').format('DD/MM/YYYY HH:mm')}` , 200, 286, { 'align': 'right' });
  } else {
    doc.text(`Fecha de Emisión: ${moment.utc(new Date()).add(-3, 'hours').format('DD/MM/YYYY HH:mm')}` , 280, 199, { 'align': 'right' });
  }
}

export { drawCabeceraLogo, drawCabeceraEmpresa, drawCabeceraFiscalEmpresa, drawFooterEmpresa };
